// extracted by mini-css-extract-plugin
module.exports = {"StaticPage":"StaticPage_StaticPage__RlOCN"};